var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66699 13.334C1.66699 10.977 1.66699 9.79845 2.39923 9.06622C3.13146 8.33398 4.30997 8.33398 6.66699 8.33398H13.3337C15.6907 8.33398 16.8692 8.33398 17.6014 9.06622C18.3337 9.79845 18.3337 10.977 18.3337 13.334C18.3337 15.691 18.3337 16.8695 17.6014 17.6018C16.8692 18.334 15.6907 18.334 13.3337 18.334H6.66699C4.30997 18.334 3.13146 18.334 2.39923 17.6018C1.66699 16.8695 1.66699 15.691 1.66699 13.334Z",
    stroke: "#2058E7",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 8.33268V6.66602C5 3.90459 7.23858 1.66602 10 1.66602C12.7614 1.66602 15 3.90459 15 6.66602V8.33268",
    stroke: "#2058E7",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4053_20162"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBox);
export default __webpack_public_path__ + "static/media/CloseBox.49d81e4448c02b601685395ef7160537.svg";
export { ForwardRef as ReactComponent };